export const DashboardMonitor = ({ size = "16" }: { size?: string }) => {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_264_7158)">
        <path
          d="M9.99984 7.59766C9.99984 8.27699 9.7945 8.90699 9.44517 9.43366L7.33317 7.32166V4.33166C8.8545 4.64032 9.99984 5.98499 9.99984 7.59766ZM5.99984 4.33166C4.4785 4.64032 3.33317 5.98499 3.33317 7.59766C3.33317 9.43832 4.82584 10.931 6.6665 10.931C7.34584 10.931 7.97584 10.7257 8.5025 10.3763L5.99984 7.87366V4.33166ZM11.3332 5.59766H13.9998V4.26432H11.3332V5.59766ZM11.3332 8.26432H13.9998V6.93099H11.3332V8.26432ZM11.3332 10.931H13.9998V9.59766H11.3332V10.931ZM9.33317 13.5977V14.931H12.6665V16.2643H4.6665V14.931H7.99984V13.5977H0.666504V3.59766C0.666504 2.49499 1.56384 1.59766 2.6665 1.59766H14.6665C15.7692 1.59766 16.6665 2.49499 16.6665 3.59766V13.5977H9.33317ZM1.99984 12.2643H15.3332V3.59766C15.3332 3.23032 15.0345 2.93099 14.6665 2.93099H2.6665C2.2985 2.93099 1.99984 3.23032 1.99984 3.59766V12.2643Z"
          fill="#706A85"
        />
      </g>
      <defs>
        <clipPath id="clip0_264_7158">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(0.666504 0.931641)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
